import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M9 9v-2","key":"svg-1"}],["path",{"d":"M12 13v-6","key":"svg-2"}],["path",{"d":"M15 11v-4","key":"svg-3"}]]

const IconAlignBoxTopCenter = createReactComponent('outline', 'align-box-top-center', 'AlignBoxTopCenter', __iconNode);

export default IconAlignBoxTopCenter;